import Calendar from './src/calendar.mjs';
export { calendarEmits, calendarProps } from './src/calendar2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCalendar = withInstall(Calendar);

export { ElCalendar, ElCalendar as default };
//# sourceMappingURL=index.mjs.map
